import { SceneSpine } from "GameObjects/StoryGame/SceneSpine";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Bounce, Circ, Elastic, Expo, Linear, Sine, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch10_p04 } from "../../../layouts/ch10_p04/ch10_p04";

export class Chapter10Page4 extends AbstractStoryState implements ReturnType<typeof ch10_p04> {
    readonly bg = this.addChild(new SceneSprite());
    readonly characters = [
        this.addChild(new SceneSprite()),
        this.addChild(new SceneSprite()),
    ];

    readonly confettiContainer = this.addChild(new PIXI.Container());
    readonly confetti = list(()=>this.confettiContainer.addChild(SceneSprite.withPrefix("ch10_p04/")));

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch10_p04/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch10_p04/"));

    dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch10_p04.call(this);

        this.characters[0].visible = true;
        this.characters[1].visible = false;

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();
        TweenLite.delayedCall(1.5, ()=>{
            this.characters[0].FadeOut();
            this.characters[1].FadeIn();
        });
        TweenLite.delayedCall(4, ()=>{
            this.gotoNextState({transition: "fade"});
        });
    }
}